/**
 * useIsFilterInModal
 */
import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';

import { FILTER_BREAKPOINT } from 'bdvp-advanced-search/src/utils/constants';
import { useMedia } from 'bdvp-common/src/hooks';

const useIsFilterInModal = () => {

    const isFilterInModal = useMedia(
        [`(min-width: ${BREAKPOINTS[FILTER_BREAKPOINT]})`],
        [false],
        true
    );

    return isFilterInModal;

};

export default useIsFilterInModal;
